module.exports = __webpack_public_path__ + "static/checklist-4a8a2ea8a0169349d5955c6d710fc924.svg";